<template>
  <div />
</template>

<script>
import HandleAuth from '../../mixins/HandleAuth'

export default {
  name: 'Impersonate',

  middleware: 'auth',

  layout: 'DefaultLayout',

  mixins: [HandleAuth],

  async created() {
    try {
      await this.impersonate(this.$route.params.email)
    } catch (e) {
      await this.$router.replace({ name: 'not-found' })
    }
  },
}
</script>
